// import readXlsxFile from 'read-excel-file';
import React, { Component } from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import 'date-fns';
import Spinner from 'react-bootstrap/Spinner';

import Summary from './Summary';
import SalesSummary from './SalesSummary';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

class ActivationSummary extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            alert: 0,
            alertMessage: '',
            flag1: false,
            flag2: false,
            showLoading: true,
            allstoreTag: [],
            storedata: [],
            storeTag: '',
            sheetsFlag: 0,
            step1RevStore: 0,
            step2RevStore: 0,
            step3RevStore: 0,
            step4RevStore: 0,
            selectedTab: '',
            uploadSpinner: false,
            fromDate: this.getFormattedDate('firstDay'),
            toDate: this.getFormattedDate('lastDay'),

            salefromDate: '2022-08-06',
            saletoDate: '2022-08-10',

            storeSheetdata: ['Fee_Orders'],
            lastUpdatedOrders: '',
            UpcommingSales: ''
        };
    }

    getFormattedDate(dateType) {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        if (dateType == 'firstDay') {
            var firstDay = new Date(y, m, 1);
        } else {
            var firstDay = new Date(y, m + 1, 0);
        }
        var dd = String(firstDay.getDate()).padStart(2, '0');
        var mm = String(firstDay.getMonth() + 1).padStart(2, '0');
        var yyyy = firstDay.getFullYear();

        var newdate = yyyy + '-' + mm + '-' + dd;
        return newdate;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.fetchLastUpdated();
        this.getUpcommingSales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async getUpcommingSales() {
        await RestServices.getUpcommingSales(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                

                if (this._isMounted) {
                    this.setState({ UpcommingSales: responseData });
                }
            })

            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }
    async fetchLastUpdated() {
        await RestServices.getFeeOrdersLastUpdate(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error,
                            showLoading: false
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            flag1: true,
                            lastUpdatedOrders: responseData,
                            showLoading: false
                        });
                    }
                }
            })

            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }


    
	
    render() {
        return (
            <Container>
                <Row style={{ justifyContent: 'space-between' }}>
                    <h4 style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                        Store Activation Summary
                    </h4>
                    <div>
                        <h6 style={{ marginTop: '1rem', marginRight: '1rem' }}>
                            TOV = Total Order Value
                        </h6>
                        <h6 style={{ marginTop: '1rem', marginRight: '1rem' }}>
                            TOC = Total Order Count
                        </h6>
                    </div>
                </Row>

                {this.state.flag1 && (
                    <div>
                        <Row>
                            <p
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Last Updated: {getFormattedDateTime(this.state.lastUpdatedOrders)}
                            </p>
                        </Row>

                        <div>
                            <hr />
                        </div>

                        <Summary />
                    </div>
                )}

                {this.state.UpcommingSales.salefrom && (
                    <div>
                        <Row style={{ justifyContent: 'space-between' }}>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                {this.state.UpcommingSales.saletitle} Activation
                                Summary ({this.state.UpcommingSales.salefrom} To{' '}
                                {this.state.UpcommingSales.saleto})
                            </h4>
                        </Row>

                        <div>
                            <hr />
                        </div>

                        <SalesSummary
                            UpcommingSales={this.state.UpcommingSales}
                        />
                    </div>
                )}
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(ActivationSummary);
